import { Middleware } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

import {
  attacksSlice,
  AttacksState,
  stopPollingAttacksAction,
  toggleAreAttackNotesVisible,
  toggleIsAttacksFiltersSidebarOpenAction,
  togglePollingAttacksAction,
} from './attacks.slice';

export const attacksMiddleware: Middleware = (api) => (next) => (action) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const actionType = action?.type as string;
  const attacksStateBeforeAction = api.getState()?.[attacksSlice.name];

  if (attacksStateBeforeAction) {
    // NOTE: Middleware is executed BEFORE given action
    attacksMiddlewaresBeforeAction[actionType]?.(attacksStateBeforeAction);
  }

  const result = next(action);
  const attacksStateAfterAction = api.getState()?.[attacksSlice.name];

  if (attacksStateAfterAction) {
    // NOTE: Middleware is executed AFTER given action
    attacksMiddlewaresAfterAction[actionType]?.(attacksStateAfterAction);
  }

  return result;
};

type MiddlewareCallback = (state: AttacksState) => unknown;

const attacksMiddlewaresBeforeAction: Record<string, MiddlewareCallback> = {};

const attacksMiddlewaresAfterAction: Record<string, MiddlewareCallback> = {
  [togglePollingAttacksAction.type]: (state: AttacksState) => {
    appStorage.attack.setIsPolling(state.isPolling);
  },

  [stopPollingAttacksAction.type]: (state: AttacksState) => {
    appStorage.attack.setIsPolling(state.isPolling);
  },

  [toggleIsAttacksFiltersSidebarOpenAction.type]: (state: AttacksState) => {
    appStorage.attack.setIsFiltersSidebarOpen(state.isAttacksFiltersSidebarOpen);
  },

  [toggleAreAttackNotesVisible.type]: (state: AttacksState) => {
    appStorage.attack.setAreNotesVisible(state.areAttackNotesVisible);
  },
};
